import React from "react";
import '../index.css';
import Header from '../components/Header';
import Footer from "../components/Footer"; 
import homebanner from "../assets/home-banner.png"; 
import Pagetitlesection from "../components/pagetitlesection"; 

function FAQpage() {
  return (
    <>
      <Header />
      <div className="page-body-container">
        <Pagetitlesection title="Frequently Asked Questions (FAQ)" backgroundImage={homebanner} />

  <div className="md:container mx-auto px-6 sm:px-6 py-10 flex flex-col items-center justify-center ">
    <section className="bg-white p-4 sm:p-10 rounded-lg shadow-lg text-gray-800 leading-relaxed max-w-4xl w-full">
 
      <div className="space-y-6">
        <div>
          <h3 className="font-semibold text-lg text-primarycolor">Q1. What is Giffypedia?</h3>
          <p className="ml-4 mt-1 text-gray-700">Giffypedia is a platform where you can create and share your personal profile with basic details and photos, making it easy to share with others.</p>
        </div>
        <div>
          <h3 className="font-semibold text-lg text-primarycolor">Q2. How do I create a profile?</h3>
          <p className="ml-4 mt-1 text-gray-700">Click on the “Create Profile” button, enter your details, upload a photo, and save. Your profile link will be ready to share instantly.</p>
        </div>
        <div>
          <h3 className="font-semibold text-lg text-primarycolor">Q3. Is it free to use Giffypedia?</h3>
          <p className="ml-4 mt-1 text-gray-700">Yes, basic profile creation is free. We may offer premium features in the future.</p>
        </div>
        <div>
          <h3 className="font-semibold text-lg text-primarycolor">Q4. Can I edit my profile later?</h3>
          <p className="ml-4 mt-1 text-gray-700">Yes, you can log in anytime and update your profile information or photo.</p>
        </div>
        <div>
          <h3 className="font-semibold text-lg text-primarycolor">Q5. Who can see my profile?</h3>
          <p className="ml-4 mt-1 text-gray-700">Profiles can be public or private based on your chosen privacy settings.</p>
        </div>
        <div>
          <h3 className="font-semibold text-lg text-primarycolor">Q6. How can I delete my profile?</h3>
          <p className="ml-4 mt-1 text-gray-700">Go to Settings → Delete Profile. Once deleted, it cannot be restored.</p>
        </div>
        <div>
          <h3 className="font-semibold text-lg text-primarycolor">Q7. Is my data safe?</h3>
          <p className="ml-4 mt-1 text-gray-700">Yes, we follow standard security measures to protect your data.</p>
        </div>
      </div>
    </section>
  </div>

        <Footer />
      </div>
    </>
  );
}

export default FAQpage;
